import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';


const watchEvents = () => {
  $('[data-fancybox="gallery"]').fancybox({
    hash: false
  });
}

const ImageFancyBox = () => {
  watchEvents();
}

export default ImageFancyBox


// WEBPACK FOOTER //
// ./src/js/app/components/ImageFancybox.js